<template>
  <el-select
    :disabled="disabled"
    :multiple="multiple"
    clearable
    filterable
    :reserve-keyword="false"
    collapse-tags
    @change="handleChange"
    :value="data"
    placeholder="请选择"
  >
    <el-option
      :label="item.name"
      :value="item.value"
      v-for="(item, index) in sitePoint"
      :key="index"
    ></el-option>
  </el-select>
</template>

<script>
import { getCascade } from "@/services/deviceType";

export default {
  name: "MultipleSite",
  props: {
    value: {},
      operatorIds: {default(){
              return []
          }},
      siteGroupId: {default(){
              return ""
          }},

    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { data: [], sitePoint: [] };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    operatorIds: {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadData(value);
        } else {
          this.sitePoint = [];
           this.data=[];
        }
      },
    },
      siteGroupId:{
          immediate: true,
          handler(value) {
              this.loadData(this.operatorIds);

          },
      },
   value:{
      immediate: true,
      handler(value) {
          this.data=value;
      }
    }
  },
  methods: {
    handleChange(value) {
        this.$emit("input",value);
        // this.$emit("input", value)
                this.$emit("change", value)
        this.data=value;
        // console.log(this.data)
    },
    async loadData(operatorIds) {
      this.sitePoint = [];
      this.data = [];
      // this.$emit("input", []);
      // this.$emit("change", [])
      if (operatorIds) {
        const response = await getCascade({ operatorIds: operatorIds ,siteGroupId:this.siteGroupId?this.siteGroupId.value:''});
        if (response && response.data.SiteName) {
          this.sitePoint = response.data.SiteName.map((item, i) => {
            return {
              name: item.name,
              value: item.id,
              allianceBrand: item.allianceBrand,
            };
          });
          //  console.log(this.sitePoint);
          //  this.$emit('getson', this.sitePoint)
        }
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/operation/MultipleSite.vue